export function createIsMatchRegex(regex: RegExp) {
  return (toMatch = '') => toMatch.match(regex);
}
